// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindVariants = require("../../../../v5/bindings/TailwindVariants.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TailwindVariants$1 = require("tailwind-variants");
let ReactAriaComponents = require("react-aria-components");

let track = TailwindVariants$1.tv({
  extend: TailwindVariants.Utils.focusRing,
  base: "relative w-full h-full flex items-center shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out border border-transparent",
  variants: {
    isSelected: {
      false: "bg-zinc-200 group-pressed:bg-gray-500",
      true: "bg-tan-gold group-pressed:bg-gray-800"
    },
    isDisabled: {
      true: "bg-zinc-100 cursor-not-allowed"
    }
  }
});

let handle = TailwindVariants$1.tv({
  base: "absolute top-[1px] left-[1px] h-[20px] w-[20px] rounded-full bg-white [box-shadow:0_1px_2px_0_rgba(0,0,0,0.25)] transition-transform duration-200 ease-in-out",
  variants: {
    isSelected: {
      false: "translate-x-0",
      true: "translate-x-[36px]"
    },
    isDisabled: {
      true: "bg-zinc-200"
    }
  }
});

let textHolder = TailwindVariants$1.tv({
  base: "absolute top-0 left-0 right-0 bottom-0 flex justify-between items-center px-2 pointer-events-none text-sm font-medium leading-[24px]"
});

let textOn = TailwindVariants$1.tv({
  base: "transition-all duration-150 text-white",
  variants: {
    isSelected: {
      false: "opacity-0 -translate-x-2",
      true: "opacity-100 translate-x-0"
    },
    isDisabled: {
      true: "text-zinc-400"
    }
  }
});

let textOff = TailwindVariants$1.tv({
  base: "transition-all duration-150",
  variants: {
    isSelected: {
      false: "opacity-100 translate-x-0 text-gray-500",
      true: "opacity-0 translate-x-2 text-gray-500"
    },
    isDisabled: {
      true: "text-gray-400"
    }
  }
});

let Styles = {
  track: track,
  handle: handle,
  textHolder: textHolder,
  textOn: textOn,
  textOff: textOff
};

function Form__Switch(props) {
  let children = props.children;
  let __offText = props.offText;
  let __onText = props.onText;
  let onText = __onText !== undefined ? __onText : "On";
  let offText = __offText !== undefined ? __offText : "Off";
  return JsxRuntime.jsx(ReactAriaComponents.Switch, {
    id: props.id,
    onChange: props.onToggle,
    isSelected: props.on,
    isDisabled: props.disabled,
    children: renderProps => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("span", {
              className: handle(renderProps)
            }),
            JsxRuntime.jsxs("span", {
              children: [
                JsxRuntime.jsx("span", {
                  children: onText,
                  className: textOn(renderProps)
                }),
                JsxRuntime.jsx("span", {
                  children: offText,
                  className: textOff(renderProps)
                })
              ],
              className: textHolder(renderProps)
            })
          ],
          className: track(renderProps)
        }),
        children !== undefined ? children : null
      ]
    }),
    className: "w-[60px] h-[24px]"
  });
}

let make = Form__Switch;

exports.Styles = Styles;
exports.make = make;
/* track Not a pure module */
